import { vars } from '@app/config'

import { hasCookie } from './hasCookie'
import { isBuyerView } from './isBuyerView'

export const isBuyerTokenMode = () =>
  isBuyerView() && hasCookie(vars.buyer_access_token)
